import { render, staticRenderFns } from "./PaySuccessBack.vue?vue&type=template&id=94dafc74&scoped=true"
import script from "./PaySuccessBack.vue?vue&type=script&lang=js"
export * from "./PaySuccessBack.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessBack.vue?vue&type=style&index=0&id=94dafc74&prod&lang=less&scoped=true"
import style1 from "./PaySuccessBack.vue?vue&type=style&index=1&id=94dafc74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dafc74",
  null
  
)

export default component.exports